var map = {
	"./bell.png": 5217,
	"./butterfly.png": 7855,
	"./candle.png": 8892,
	"./coin.png": 1499,
	"./compass.png": 1691,
	"./custom.png": 7037,
	"./eclipse.png": 6308,
	"./evil.png": 1836,
	"./fabled.png": 5025,
	"./good.png": 6832,
	"./hourglass.png": 4181,
	"./imp.png": 2830,
	"./keys.png": 6584,
	"./lantern.png": 8013,
	"./loom.png": 1046,
	"./mask.png": 1322,
	"./minion.png": 847,
	"./outsider.png": 8814,
	"./quill.png": 5477,
	"./ravenkeeper.png": 6965,
	"./thorns.png": 9777,
	"./x.png": 1139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;